module.exports = __webpack_public_path__ + "common/icon-check-primary-0f4bd961ff724a00b40005371a8b6753.svg";